const config = {
    apiURL: process.env.REACT_APP_API_URL,
    storageURL: process.env.REACT_APP_STORAGE_URL
}

export default config